module.exports = __webpack_public_path__ + "static/fundament-s-podvalom-90def1c787ca74660d669ffc370acd72.jpg";